import React from 'react';
import './Skeleton.scss';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  variant?: 'rectangular' | 'circular' | 'text';
  animation?: 'pulse' | 'wave' | 'none';
  count?: number;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  className = '',
  variant = 'rectangular',
  animation = 'pulse',
  count = 1
}) => {
  const skeletonClasses = [
    'skeleton',
    `skeleton--${variant}`,
    `skeleton--${animation}`,
    className
  ].filter(Boolean).join(' ');

  const style: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  if (count === 1) {
    return (
      <div className={skeletonClasses} style={style} />
    );
  }

  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={skeletonClasses} style={style} />
      ))}
    </>
  );
};

export default Skeleton;
